const landing = {
    description: "Domino's Srilanka delivers tastiest pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
    title: "Order Pizza Online | Domino's Srilanka",
    keywords: "Domino's Srilanka, Domino's Pizza"
}

const pastaPizza = {
    description: "Pasta Pizza - Domino's Srilanka delivers tastiest pasta pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
    title: "Order Pasta Pizza Online | Domino's Srilanka",
    keywords: "Pasta Pizza"
}

const srilankaSeoData = {
    '/': landing,

    '/menu/bestsellers': landing,
    '/menu/1': landing,

    '/menu/44': pastaPizza,

    '/menu/veg-pizza': {
        description: "Veg Pizza -Domino's Srilanka delivers tastiest veg pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Veg Pizza Online | Domino's Srilanka",
        keywords: "Veg pizza"
    },
    '/menu/non-veg-pizza': {
        description: "Non Veg Pizza - Domino's Srilanka delivers tastiest Non-Veg pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order NonVeg Pizza Online | Domino's Srilanka",
        keywords: "Non Veg Pizza"
    },
    '/menu/43': {
        description: "Meals & Combos - Domino's Srilanka delivers tastiest pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Meals and Combos Online | Domino's Srilanka",
        keywords: "Meal and Combos"
    },

    '/menu/sides': {
        description: "Sides - Domino's Srilanka delivers tastiest pizza online at best prices. Order Garlic Breadstic, Chicken wings and Get delivered at your doorstep.",
        title: "Order Sides Online | Domino's Srilanka",
        keywords: "Sides"
    },
    '/menu/40': {
        description: "Rice & Pasta - Domino's Srilanka delivers tastiest rice & Pasta online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Pasta and Rice Online | Domino's Srilanka",
        keywords: "Pasta and Rice"
    },
    '/menu/41': {
        description: "Domino's Srilanka delivers tastiest pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Desserts Online | Domino's Srilanka",
        keywords: "Desserts"
    },
    '/menu/beverages': {
        description: "Beverages - Domino's Srilanka delivers beverages online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Beverages Online | Domino's Srilanka",
        keywords: "Beverages"
    },
    '/menu/35': {
        description: "All Day Favourites Pizza -  Domino's Srilanka delivers tastiest pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order All day favourites Pizza Online | Domino's Srilanka",
        keywords: "All day favourite pizza"
    },
    '/menu/37': {
        description: "Simply Cheese Pizza Range - Domino's Srilanka delivers tastiest pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Pizza from Simply Cheese Range Online | Domino's Srilanka",
        keywords: "Simply Cheese Pizza range"
    },
    '/menu/38': {
        description: "Supreme Pizza Range - Domino's Srilanka delivers tastiest pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Pizza from Supreme Pizza Range Online | Domino's Srilanka",
        keywords: "Supreme Pizza range"
    },
    '/menu/39': {
        description: "Loaded Pizza Range - Domino's Srilanka delivers tastiest pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
        title: "Order Loaded Pizza Online | Domino's Srilanka",
        keywords: "Loaded Pizza range"
    }
};

module.exports = srilankaSeoData;
